
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/van/overlanding",
      function () {
        return require("private-next-pages/rims/van/overlanding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/van/overlanding"])
      });
    }
  